<template>
  <div 
    class="ios-row" 
    :class="{ 
      'ios-row--clickable': clickable, 
      'ios-row--first': first,
      'ios-row--last': last,
      'ios-row--no-padding': noPadding
    }"
    @click="handleClick"
  >
    <div v-if="$slots.icon" class="row-icon">
      <slot name="icon"></slot>
    </div>
    
    <div class="row-content">
      <div class="row-left">
        <div class="row-label">{{ label }}<span v-if="required" class="required-star">*</span></div>
        <div v-if="subtitle" class="row-subtitle">{{ subtitle }}</div>
      </div>
      
      <div class="row-right">
        <slot name="value">
          <span v-if="value" class="row-value">{{ value }}</span>
        </slot>
        <v-icon v-if="clickable && showChevron" size="18" class="row-chevron">mdi-chevron-right</v-icon>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  },
  value: {
    type: String,
    default: ''
  },
  clickable: {
    type: Boolean,
    default: false
  },
  showChevron: {
    type: Boolean,
    default: true
  },
  first: {
    type: Boolean,
    default: false
  },
  last: {
    type: Boolean,
    default: false
  },
  noPadding: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['click']);

const handleClick = () => {
  emit('click');
};
</script>

<style lang="scss" scoped>
.required-star {
  color: #F44336;
  font-weight: 700;
}
/* All .ios-row and .row-* styles are in global main.scss */
</style>
